import angular from 'angular';

import QuestionsPhonePreview from './questions-phone-preview/questions-phone-preview';

const Components = angular.module('control-room.app-settings.components.preferences-phone-preview.components', [
    QuestionsPhonePreview.name,
]);

export default Components;
